export const hideColumnChooserOnBackdrop = {
  methods: {
    hideColumnChooserOnBackdropFn() {
      // Event listener for hiding column chooser
      this.$nextTick(() => {
        document.addEventListener("mousedown", (event) => {
          const isColumnChooser = event
            .composedPath()
            .some((element) => element?.matches?.(".dx-overlay-content"));
          if (!isColumnChooser) {
            this.treelist.hideColumnChooser();
          }
        });
      });
    },
  },
};
